import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledNavbar = styled(Grid)`
  display: flex;
  justify-content: space-between;
  background: ${colors.blue700};
  width: 100%;
  height: 88px;
  padding: 24px 64px 24px 64px;
  border: 0px 0px 1px 0px;
  justify: space-between;

  box-shadow: 0px 6px 10px 0px #c2ccf333;
  box-shadow: 0px 4px 8px 0px #c2ccf333;
  box-shadow: 0px 2px 6px 0px #c2ccf34d;
  box-shadow: 0px 2px 4px 0px #c2ccf359;
`;

export const Title = styled(Typography)`
  color: ${colors.white};
  font-weight: 700;
`;
